import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ o("path", { d: "M14.678 11.33h-.038a1.287 1.287 0 0 1-1.288-1.279V5.94C13.332 3.03 10.976.663 8.076.606h-.143c-2.91.057-5.267 2.423-5.295 5.333v4.112c0 .706-.582 1.279-1.317 1.279a.72.72 0 0 0-.716.715.72.72 0 0 0 .716.716H5.29A2.717 2.717 0 0 0 8 15.394a2.717 2.717 0 0 0 2.71-2.633h3.968a.72.72 0 0 0 .716-.716.72.72 0 0 0-.716-.715ZM8 13.963a1.29 1.29 0 0 1-1.28-1.203h2.557A1.29 1.29 0 0 1 8 13.963ZM3.754 11.33c.2-.382.324-.811.324-1.279V5.95c.02-2.147 1.775-3.893 3.931-3.912 2.156.02 3.912 1.765 3.93 3.902v4.112c0 .458.115.897.325 1.279h-8.51Z" }, null, -1), a = [
  n
];
function r(s, h) {
  return e(), t("svg", c, [...a]);
}
const d = { render: r };
export {
  d as default,
  r as render
};
